import React from "react";
import { useSelector } from "react-redux";
import { Button, Grid } from "semantic-ui-react";
import { getAdmin, getJobPromotionalRequests } from "../adminSelectors";
import { SOCIAL_MEDIA_PROMOTION_REQUEST } from "../../employer/helpers/createPromotionRequest";
import ReviewItem from "./ReviewItem";
import {
  updateDocument,
  updateStatusLogForServiceInFirestore,
} from "../../../app/firestore/firestoreService";
import {
  FIRESTORE_PROMOTION_REQUESTS_COLLECTION,
  LOG_STATUS_JOB_PROMOTED_SOCIALS,
} from "../../../app/firestore/firestoreConstants";
import { getFullDate } from "../../../js/helpers/dateHelpers";

export default function ReviewPromotionalRequests() {
  const { jobs } = useSelector((state) => getAdmin(state));

  const socialMediaPromotions = getJobPromotionalRequests(jobs).filter(
    (request) => request.type === SOCIAL_MEDIA_PROMOTION_REQUEST
  );

  async function fullFillPromotionRequest(request) {
    const date = new Date();
    await updateDocument({
      dbCollection: FIRESTORE_PROMOTION_REQUESTS_COLLECTION,
      id: request.id,
      data: {
        isFulfilled: true,
        dateFulfilled: date,
      },
    });
    await updateStatusLogForServiceInFirestore({
      id: request.ref,
      date: date,
      status: LOG_STATUS_JOB_PROMOTED_SOCIALS,
    });
  }

  return (
    <Grid>
      <Grid.Column width={16}>
        <br />
        <div className="body-blue-text semi-bold">
          Social Media orders ({socialMediaPromotions.length}):
        </div>
        <br />
        <div>
          {socialMediaPromotions.length > 0 ? (
            socialMediaPromotions.map((request) => (
              <ReviewItem
                date={
                  <>
                    <span>Approved: </span>
                    <span>{getFullDate(request.dateCreated)}</span>
                  </>
                }
                key={request.id}
                details={
                  <span>
                    {request.title} - {request.company}
                  </span>
                }
                actionButton={
                  <Button
                    className="overwrite-button orange-inverse-button"
                    style={{ marginLeft: 10 }}
                    onClick={() => fullFillPromotionRequest(request)}
                  >
                    Complete
                  </Button>
                }
              />
            ))
          ) : (
            <span className="manage-item-list-no-item">
              No Social Media orders
            </span>
          )}
        </div>
      </Grid.Column>
    </Grid>
  );
}
